import OpenWithIcon from "@mui/icons-material/OpenWith";
import ImageWithPlaceholder from "../../../components/ImageWithPlaceholder";

export default function PosItemCard({ item, index, onClick, isDragDropMode }) {
    const { name, item_code, cover } = item;

    const handleClick = (e) => {
        if (e.defaultPrevented) return;
        if (onClick) {
            onClick(item);
        }
    };

    const imageStyle = {
        width: "100px",
        height: "100px",
        objectFit: "cover",
        borderRadius: "8px",
    };

    return (
        <div
            onClick={handleClick}
            style={{
                width: "100%",
                position: "relative",
                borderRadius: "4px",
                background: "rgba(255, 255, 255, 0.7)",
            }}
        >
                         <div className="Item" key={`Item_1_${item_code}`}>
                 <ImageWithPlaceholder
                     src={cover}
                     alt={item.item_name}
                     style={imageStyle}
                 />
                <div
                    style={{
                        // position: 'absolute',
                        top: 0,
                        right: 0,
                        // background: 'rgba(255, 255, 255, 0.7)', // Semi-transparent background
                        padding: "5px",
                        // borderRadius: '4px'
                    }}
                >
                    <div className={"MainDetails"} key={`Item_2_${item_code}`}>
                        <div className={"Name"} key={`Item_name_${item_code}`} style={{fontSize: "18px", lineHeight: "1.2"}}>
                            {item.item_name}
                        </div>
                    </div>
                    {isDragDropMode && (
                        <div className={"Name"}>
                            <OpenWithIcon />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
